import { render, staticRenderFns } from "./ProfileAccountComponent.vue?vue&type=template&id=58f4bc4e&scoped=true"
import script from "./ProfileAccountComponent.vue?vue&type=script&lang=js"
export * from "./ProfileAccountComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileAccountComponent.vue?vue&type=style&index=0&id=58f4bc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4bc4e",
  null
  
)

export default component.exports